// src/CSPHelper.js
import React, { useEffect } from 'react';

// This component will help us manage the CSP directly
const CSPHelper = () => {
  useEffect(() => {
    // Remove any existing CSP meta tags
    const existingCSPTags = document.querySelectorAll('meta[http-equiv="Content-Security-Policy"]');
    existingCSPTags.forEach(tag => tag.remove());
    
    // Create and add our new CSP meta tag - keeping it consistent with setupProxy.js
    const newCSPTag = document.createElement('meta');
    newCSPTag.httpEquiv = 'Content-Security-Policy';
    newCSPTag.content = `
      default-src 'self'; 
      connect-src 'self' https://*.googleapis.com https://*.google.com https://firebase.googleapis.com 
                  https://firebaseinstallations.googleapis.com https://identitytoolkit.googleapis.com 
                  https://*.firebaseio.com wss://*.firebaseio.com https://region1.google-analytics.com
                  https://*.agora.io wss://*.agora.io:* https://*.agoralab.co https://*.agoraio.cn
                  https://*.sd-rtn.com wss://*.sd-rtn.com:* https://*.edge.agora.io wss://*.edge.agora.io:* 
                  https://*.agora-sd-rtn.com ws://localhost:* wss://localhost:*;
      script-src 'self' https://*.googleapis.com https://*.google.com https://apis.google.com 
                 https://www.gstatic.com https://accounts.google.com https://www.googletagmanager.com 
                 'unsafe-inline' 'unsafe-eval' blob: data:; 
      style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; 
      font-src 'self' data: https://fonts.gstatic.com; 
      img-src 'self' data: https: blob:;
      frame-src https://accounts.google.com https://content.googleapis.com 
               https://*.google.com https://*.firebaseapp.com; 
      media-src 'self' blob:;
      worker-src 'self' blob:;
    `.replace(/\s+/g, ' ').trim();
    
    document.head.appendChild(newCSPTag);
    
    console.log('CSP has been dynamically updated by CSPHelper component');
  }, []);

  return null; // This component doesn't render anything
};

export default CSPHelper;